import React from 'react';
import {
  Box, Typography, IconButton, TextField,
  Card, CardContent, Divider, Stack
} from '@mui/material';
import { Add, Remove, DeleteOutline } from '@mui/icons-material';
import BoxComponent from '../../../../../components/Box/BoxComponent';
import TypographyComponent from '../../../../../components/Typography/ThypographyComponent';
import { formatNumberToDinheiro } from '../../../../../utils/dinheiro';

interface Props {
  item: any; // Substitua pelo seu tipo ItemCarrinho
  onIncrement: (id: string) => void;
  onDecrement: (id: string) => void;
  onRemove: (id: string) => void;
  onObsChange: (id: string, obs: string) => void;
}

const ItemCarrinhoCardComponent = ({ item, onIncrement, onDecrement, onRemove, onObsChange }: Props) => {
  let totalComplementos = 0;

  console.log("ITEM DO CARRINHO: ", item)

  if (Array.isArray(item.complementos)) {
    totalComplementos += item.complementos.reduce(
      (soma: number, c: any) => soma + c.vlrUnitario,
      0
    );
  }

  if (Array.isArray(item.complementosEspecificos)) {
    totalComplementos += item.complementosEspecificos.reduce(
      (soma: number, c: any) => soma + c.vlrUnitario,
      0
    );
  }

  const subtotal = (item.vlrUnitario + totalComplementos) * item.qtd;

  return (
    <Card variant="outlined" sx={{ mb: 2, borderRadius: 2, backgroundColor: "#F9FAFB", minHeight: "120px" }}>
      <CardContent>
        <Stack direction="row" spacing={2} alignItems="center">
          {/* Foto do Item */}
          <BoxComponent
            component="img"
            src={item.item.midias[0].caminho || 'https://via.placeholder.com/80'}
            alt={item.item.midias[0].nome}
            sx={{ width: 80, height: 80, borderRadius: 1, objectFit: 'cover' }}
          />

          <BoxComponent component="div" sx={{ flexGrow: 1 }}>
            <TypographyComponent variant="h3"
              sx={{
                fontFamily: '"Font 2", sans-serif',
                fontWeight: 600,
                fontSize: '14px',
                lineHeight: '20px',
                letterSpacing: '0%',
                color: '#101828',
                display: 'inline-flex',
                alignItems: 'center',
                verticalAlign: 'middle'
              }}
            >
              {item.item.nome}
            </TypographyComponent>
            <TypographyComponent
              variant="body2"
              sx={{
                fontFamily: '"Font 1", sans-serif',
                fontWeight: 700,
                fontSize: '16px', // Mapeado do token 's'
                lineHeight: '24px',
                letterSpacing: '0%',
                color: '#E7000B',
                display: 'inline-flex',
                alignItems: 'center',
                verticalAlign: 'middle'
              }}
            >
              {formatNumberToDinheiro(subtotal)}
            </TypographyComponent>

            {/* Controles de Quantidade e Observação */}
            <Stack direction={{ xs: 'column', sm: 'row' }} alignItems="center">
              <Stack direction="row" alignItems="center" sx={{}}>
                <IconButton
                  size="small"
                  onClick={() => onDecrement(item.item.id)}
                  disabled={item.qtd <= 1}
                  sx={{ color: "#1F2937" }}
                >
                  <Remove fontSize="small" />
                </IconButton>
                <TypographyComponent sx={{ mx: 2, fontWeight: 'medium', color: "#1F2937" }} >{item.qtd}</TypographyComponent>
                <IconButton size="small" onClick={() => onIncrement(item.item.id)} sx={{ color: "#1F2937" }}>
                  <Add fontSize="small" />
                </IconButton>
              </Stack>

              {/* Botão Excluir */}
              <IconButton color="error" onClick={() => onRemove(item.item.id)}>
                <DeleteOutline />
              </IconButton>

              {/* <TextField
            fullWidth
            size="small"
            label="Observações"
            placeholder="Ex: sem cebola, ponto da carne..."
            value={item.observacao || ''}
            onChange={(e) => onObsChange(item.item.id, e.target.value)}
          /> */}
            </Stack>
          </BoxComponent>
        </Stack>


      </CardContent>
    </Card>
  );
};

export default ItemCarrinhoCardComponent;